document.querySelectorAll('[data-apd-hero]').forEach(function(root){
  var startAttr = root.getAttribute('data-apd-start');
  var endAttr = root.getAttribute('data-apd-end');
  var start = startAttr ? new Date(startAttr).getTime() : NaN;
  var end = endAttr ? new Date(endAttr).getTime() : NaN;
  var clock = root.querySelector('[data-apd-clock]');
  var badge = root.querySelector('[data-apd-badge]');
  var label = root.querySelector('[data-apd-label]');
  var cta = root.querySelector('[data-apd-cta]');
  var pre = root.getAttribute('data-apd-badge-pre') || '';
  var live = root.getAttribute('data-apd-badge-live') || '';
  var f = function(n){ return String(n).padStart(2,'0'); };

  function paint(target, isPre){
    if (badge && pre && live) badge.textContent = isPre ? pre : live;
    if (label) label.textContent = isPre ? 'STARTS IN' : 'ENDS IN';
    if (cta) cta.style.display = isPre ? 'none' : '';
    if (!clock) return;
    var d = target - Date.now();
    if (d < 0) d = 0;
    var s = Math.floor(d/1000);
    var el;
    if ((el = clock.querySelector('[data-apd="d"]'))) el.textContent = Math.floor(s/86400);
    if ((el = clock.querySelector('[data-apd="h"]'))) el.textContent = f(Math.floor(s%86400/3600));
    if ((el = clock.querySelector('[data-apd="m"]'))) el.textContent = f(Math.floor(s%3600/60));
    if ((el = clock.querySelector('[data-apd="s"]'))) el.textContent = f(s%60);
  }

  function tick(){
    var now = Date.now();
    if (!isNaN(start) && now < start) { paint(start, true); return; }
    if (!isNaN(end) && now >= end) { root.style.display = 'none'; return; }
    paint(end, false);
  }

  tick();
  setInterval(tick, 1000);
});
